(function() {
  if (window.FanaticsProduct3DViewer) return;

  var state = {
    modal: null,
    stage: null,
    viewer: null,
    opener: null,
    savedScrollY: 0,
    loadToken: 0,
    modelViewerPromise: null,
    inlineStage: null,
    inlineViewer: null,
    inlineContent: null,
    bodyStyles: null,
    documentOverflow: ''
  };

  function loadingMarkup(message) {
    var loading = document.createElement('div');
    loading.className = 'fanatics-product-3d-loading';
    loading.textContent = message || 'Loading 3D model…';
    return loading;
  }

  function ensureModal() {
    if (state.modal && state.modal.isConnected) return state.modal;

    var modal = document.createElement('div');
    modal.className = 'fanatics-product-3d-modal';
    modal.setAttribute('aria-hidden', 'true');

    var overlay = document.createElement('button');
    overlay.type = 'button';
    overlay.className = 'fanatics-product-3d-overlay';
    overlay.setAttribute('data-fanatics-close-3d', '');
    overlay.setAttribute('aria-label', 'Close 3D viewer');

    var dialog = document.createElement('div');
    dialog.className = 'fanatics-product-3d-dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', '3D model viewer');

    var closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'fanatics-product-3d-close';
    closeButton.setAttribute('data-fanatics-close-3d', '');
    closeButton.setAttribute('aria-label', 'Close 3D viewer');
    closeButton.textContent = '×';

    var stage = document.createElement('div');
    stage.className = 'fanatics-product-3d-stage';
    stage.setAttribute('aria-live', 'polite');
    stage.appendChild(loadingMarkup());

    dialog.appendChild(closeButton);
    dialog.appendChild(stage);
    modal.appendChild(overlay);
    modal.appendChild(dialog);
    document.body.appendChild(modal);

    state.modal = modal;
    state.stage = stage;
    return modal;
  }

  function resetStage(message) {
    if (!state.stage) return;
    state.stage.replaceChildren(loadingMarkup(message));
    state.stage.setAttribute('aria-busy', message ? 'false' : 'true');
    state.viewer = null;
  }

  function createViewer(modelUrl, modelAlt) {
    var viewer = document.createElement('model-viewer');
    viewer.setAttribute('src', modelUrl);
    viewer.setAttribute('alt', modelAlt);
    viewer.setAttribute('camera-controls', '');
    viewer.setAttribute('reveal', 'auto');
    viewer.setAttribute('interaction-prompt', 'auto');
    viewer.setAttribute('shadow-intensity', '1');
    return viewer;
  }

  function closeInline() {
    state.loadToken += 1;

    if (state.inlineViewer) {
      state.inlineViewer.removeAttribute('src');
      state.inlineViewer.remove();
    }

    if (state.inlineStage) {
      var inlineDrawer = state.inlineStage.closest('[data-pgq-drawer]');
      if (state.inlineContent) {
        state.inlineStage.replaceChildren.apply(state.inlineStage, state.inlineContent);
      }
      state.inlineStage.setAttribute('data-view', 'image');
      state.inlineStage.removeAttribute('aria-busy');
      state.inlineStage.classList.remove('fanatics-product-3d-inline-stage');
      if (state.inlineStage.hasAttribute('data-3d-height-lock')) {
        state.inlineStage.removeAttribute('data-3d-height-lock');
        ['height', 'min-height', 'max-height', 'flex-basis'].forEach(function(prop) {
          state.inlineStage.style.removeProperty(prop);
        });
      }
      if (inlineDrawer) inlineDrawer.setAttribute('data-viewer-state', 'image');
    }

    state.inlineStage = null;
    state.inlineViewer = null;
    state.inlineContent = null;
  }

  function openInline(button, stage, modelUrl, modelAlt) {
    closeInline();
    var token = ++state.loadToken;

    state.opener = button;
    state.inlineStage = stage;
    state.inlineContent = Array.prototype.slice.call(stage.childNodes);
    var inlineDrawer = stage.closest('[data-pgq-drawer]');
    if (inlineDrawer) inlineDrawer.setAttribute('data-viewer-state', '3d');
    // PC/tablet Quick View (>=750): keep the hero box at its current size while the image is swapped for the model.
    if (inlineDrawer && window.matchMedia('(min-width: 750px)').matches) {
      var stageHeight = stage.getBoundingClientRect().height;
      if (stageHeight > 0) {
        stage.setAttribute('data-3d-height-lock', '');
        ['height', 'min-height', 'max-height', 'flex-basis'].forEach(function(prop) {
          stage.style.setProperty(prop, stageHeight + 'px', 'important');
        });
      }
    }
    stage.classList.add('fanatics-product-3d-inline-stage');
    stage.setAttribute('data-view', '3d');
    stage.setAttribute('aria-busy', 'true');
    stage.replaceChildren(loadingMarkup());

    loadModelViewerScript().then(function() {
      if (token !== state.loadToken || !stage.isConnected) return;

      var viewer = createViewer(modelUrl, modelAlt);
      viewer.addEventListener('load', function() {
        stage.setAttribute('aria-busy', 'false');
      }, { once: true });
      viewer.addEventListener('error', function() {
        if (token !== state.loadToken || !stage.isConnected) return;
        stage.replaceChildren(loadingMarkup('Unable to load 3D model.'));
        stage.setAttribute('aria-busy', 'false');
        state.inlineViewer = null;
      }, { once: true });

      stage.replaceChildren(viewer);
      state.inlineViewer = viewer;
    }).catch(function() {
      if (token !== state.loadToken || !stage.isConnected) return;
      stage.replaceChildren(loadingMarkup('Unable to load 3D model.'));
      stage.setAttribute('aria-busy', 'false');
    });
  }

  function loadModelViewerScript() {
    if (window.customElements && customElements.get('model-viewer')) {
      return Promise.resolve();
    }

    if (state.modelViewerPromise) return state.modelViewerPromise;

    state.modelViewerPromise = new Promise(function(resolve, reject) {
      var existingScript = document.querySelector('script[data-model-viewer-script]');

      if (existingScript) {
        if (window.customElements && customElements.whenDefined) {
          customElements.whenDefined('model-viewer').then(resolve).catch(reject);
        } else {
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
        }
        return;
      }

      var script = document.createElement('script');
      script.type = 'module';
      script.src = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@4.1.0/dist/model-viewer.min.js';
      script.setAttribute('data-model-viewer-script', '');
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    return state.modelViewerPromise;
  }

  function lockPage() {
    state.savedScrollY = window.scrollY || window.pageYOffset || 0;
    state.documentOverflow = document.documentElement.style.overflow;
    state.bodyStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width
    };

    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + state.savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockPage() {
    document.documentElement.style.overflow = state.documentOverflow;

    if (state.bodyStyles) {
      document.body.style.position = state.bodyStyles.position;
      document.body.style.top = state.bodyStyles.top;
      document.body.style.left = state.bodyStyles.left;
      document.body.style.right = state.bodyStyles.right;
      document.body.style.width = state.bodyStyles.width;
    }

    window.scrollTo(0, state.savedScrollY);
  }

  function close() {
    if (!state.modal || !state.modal.classList.contains('is-open')) return;

    state.loadToken += 1;
    state.modal.classList.remove('is-open');
    state.modal.setAttribute('aria-hidden', 'true');

    if (state.viewer) {
      state.viewer.removeAttribute('src');
      state.viewer.remove();
      state.viewer = null;
    }

    resetStage();
    unlockPage();

    if (state.opener && state.opener.isConnected) state.opener.focus();
    state.opener = null;
  }

  function open(button) {
    var modelUrl = button.getAttribute('data-model-url');
    var modelAlt = button.getAttribute('data-model-alt') || '3D model';
    if (!modelUrl) return;

    var quickViewDrawer = button.closest('[data-pgq-drawer]');
    var quickViewMedia = quickViewDrawer ? quickViewDrawer.querySelector('.pgq-qv-media') : null;
    // Quick View (mobile and PC): show the model in place of the hero image, no separate modal.
    if (quickViewMedia) {
      openInline(button, quickViewMedia, modelUrl, modelAlt);
      return;
    }

    var modal = ensureModal();
    var dialog = modal.querySelector('[role="dialog"]');
    var token = ++state.loadToken;

    state.opener = button;
    resetStage();
    if (dialog) dialog.setAttribute('aria-label', modelAlt + ' 3D model');
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    lockPage();

    var closeButton = modal.querySelector('.fanatics-product-3d-close');
    if (closeButton) closeButton.focus();

    loadModelViewerScript().then(function() {
      if (token !== state.loadToken || !modal.classList.contains('is-open')) return;

      var viewer = createViewer(modelUrl, modelAlt);

      viewer.addEventListener('load', function() {
        if (state.stage) state.stage.setAttribute('aria-busy', 'false');
      }, { once: true });

      viewer.addEventListener('error', function() {
        resetStage('Unable to load 3D model.');
      }, { once: true });

      state.stage.replaceChildren(viewer);
      state.viewer = viewer;
    }).catch(function() {
      resetStage('Unable to load 3D model.');
    });
  }

  document.addEventListener('click', function(event) {
    var opener = event.target.closest('[data-fanatics-open-3d]');
    if (opener) {
      event.preventDefault();
      open(opener);
      return;
    }

    if (event.target.closest('[data-fanatics-close-3d]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeInline();
      close();
    }
  });

  window.FanaticsProduct3DViewer = {
    open: open,
    close: close,
    closeInline: closeInline
  };
})();
